<template>

	<div class="bg">
		<div class="top_search_part">
			<div class="search_box">
				<div class="goBackBox" @click="goBack" style="margin-right: 20px;">
					<img class="goBackIcon" src="@/assets/backIcon.svg" />
					<span class="goBackTitle">{{ $t('message.backText') }}</span>
				</div>
				<div class="search_item">
					<img class="goBackIcon" src="@/assets/dateIcon.svg" />
					<span class="goBackTitle">{{ date }} {{ city }}</span>
				</div>
			</div>
			<div class="search_box">
				<div class="add_btn" @click="addNewOrder" style="margin-right: 20px;">
					<img class="add_icon" src="@/assets/addIcon.svg" />
					{{ $t('message.AddCarTitle') }}
				</div>
				<div class="add_btn" @click="downloadBulkExcel">
					<img class="add_icon" src="@/assets/downloadIocn.svg" />
					{{ $t('message.exportText') }}
				</div>
			</div>
		</div>
		<div class="content" style="height: calc(100% - 334px);">
			<div class="tableBox downloadtable">
				<el-table id="orderList" :data="orderList" style="width: 100%" height="100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" border>
					<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="60" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.CarNoTitle')" prop="CARNO" width="100" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.SiJiTitle')" prop="DRIVER" width="100" fixed="left">
						<template slot-scope="scope">
							<span @click="showHeaderDialog(scope.row.ID)">{{ scope.row.DRIVER === '' || scope.row.DRIVER === null ? $t('message.setStatus') : scope.row.DRIVER }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle1')" prop="DT1" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID1)"
								v-if="scope.row.DTID1 != '' && scope.row.DTENDTIME1 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT1.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 1)"
								v-html="scope.row.DT1 === '' || scope.row.DT1 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT1.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle2')" prop="DT2" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID2)"
								v-if="scope.row.DTID2 != '' && scope.row.DTENDTIME2 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT2.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 2)"
								v-html="scope.row.DT2 === '' || scope.row.DT2 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT2.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle3')" prop="DT3" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID3)"
								v-if="scope.row.DTID3 != '' && scope.row.DTENDTIME3 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT3.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 3)"
								v-html="scope.row.DT3 === '' || scope.row.DT3 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT3.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle4')" prop="DT4" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID4)"
								v-if="scope.row.DTID4 != '' && scope.row.DTENDTIME4 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT4.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 4)"
								v-html="scope.row.DT4 === '' || scope.row.DT4 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT4.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle5')" prop="DT5" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID5)"
								v-if="scope.row.DTID5 != '' && scope.row.DTENDTIME5 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT5.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 5)"
								v-html="scope.row.DT5 === '' || scope.row.DT5 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT5.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle6')" prop="DT6" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID6)"
								v-if="scope.row.DTID6 != '' && scope.row.DTENDTIME6 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT6.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 6)"
								v-html="scope.row.DT6 === '' || scope.row.DT6 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT6.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle7')" prop="DT7" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID7)"
								v-if="scope.row.DTID7 != '' && scope.row.DTENDTIME7 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT7.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 7)"
								v-html="scope.row.DT7 === '' || scope.row.DT7 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT7.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle8')" prop="DT8" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID8)"
								v-if="scope.row.DTID8 != '' && scope.row.DTENDTIME8 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT8.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 8)"
								v-html="scope.row.DT8 === '' || scope.row.DT8 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT8.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle9')" prop="DT9" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID9)"
								v-if="scope.row.DTID9 != '' && scope.row.DTENDTIME9 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT9.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 9)"
								v-html="scope.row.DT9 === '' || scope.row.DT9 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT9.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle10')" prop="DT10" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID10)"
								v-if="scope.row.DTID10 != '' && scope.row.DTENDTIME10 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT10.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 10)"
								v-html="scope.row.DT10 === '' || scope.row.DT10 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT10.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle11')" prop="DT11" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID11)"
								v-if="scope.row.DTID11 != '' && scope.row.DTENDTIME11 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT11.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 11)"
								v-html="scope.row.DT11 === '' || scope.row.DT11 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT11.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle12')" prop="DT12" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID12)"
								v-if="scope.row.DTID12 != '' && scope.row.DTENDTIME12 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT12.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 12)"
								v-html="scope.row.DT12 === '' || scope.row.DT12 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT12.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle13')" prop="DT13" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID13)"
								v-if="scope.row.DTID13 != '' && scope.row.DTENDTIME13 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT13.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 13)"
								v-html="scope.row.DT13 === '' || scope.row.DT13 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT13.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle14')" prop="DT14" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID14)"
								v-if="scope.row.DTID14 != '' && scope.row.DTENDTIME14 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT14.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 14)"
								v-html="scope.row.DT14 === '' || scope.row.DT14 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT14.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.XingChengTitle15')" prop="DT15" width="200">
						<template slot-scope="scope">
							<el-button
								class="operation_btnSmall delBtnSmall"
								type="text"
								size="mini"
								@click="DelDiaoDuDetails(scope.row.DTID15)"
								v-if="scope.row.DTID15 != '' && scope.row.DTENDTIME15 === ''"
							></el-button>
							<div
								style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"
								:style="{ color: scope.row.DT15.indexOf('◎Q') >= 0 ? ' #0048FF' : '' }"
								@click="SetCarXingCheng(scope.row.ID, 15)"
								v-html="scope.row.DT15 === '' || scope.row.DT15 === null ? '&nbsp;<br>&nbsp;' : scope.row.DT15.replace('◎Q', '').replace('◎S', '')"
							></div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChange"
				@current-change="currentChange"
				:current-page="page_no"
				:page-sizes="pageSizes"
				:page-size="page_size"
				layout="total, sizes, prev, pager, next"
				:total="totalSize"
				class="tablePage"
			></el-pagination>
		</div>

		<div class="top_search_part">
			<div class="search_box">
				<div style="margin-right: 20px;">
					<span class="goSongHuoTitle">{{ $t('message.SongHuoTitle') }}</span>
				</div>
			</div>
			<div class="search_box">
				<div class="add_btn" @click="addSongHuoOrder" style="margin-right: 20px;">
					<img class="add_icon" src="@/assets/addIcon.svg" />
					{{ $t('message.newContainerTitle') }}
				</div>
			</div>
		</div>
		<div class="content" style="height: calc(250px);">
			<div class="tableBox">
				<el-table
					id="orderListSongHuo"
					:data="orderListSongHuo"
					style="width: 100%"
					height="100%"
					stripe
					size="small"
					header-cell-class-name="tableHeader"
					cell-class-name="tableBodyer"
					@sort-change="sortChangeSongHuo"
					border
				>
					<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="60" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.XingChengTimeTitle')" prop="DETAILSTIME"></el-table-column>
					<el-table-column :label="$t('message.SongHuoXingChengTitle')" prop="TRIP"></el-table-column>
					<el-table-column :label="$t('message.containerOrderRemark')" prop="REMARK"></el-table-column>

					<el-table-column :label="$t('message.customTableTitle5')" width="100">
						<template slot-scope="scope">
							<div class="operate_btn_box">
								<el-button
									class="operation_btn updateBtn"
									type="text"
									size="small"
									@click.native.prevent="updateSongHuoOrder(scope.row)"
									v-if="isAdmin || scope.row.ISCANEDIT !== 'N'"
								></el-button>
								<el-button
									class="operation_btn delBtn"
									type="text"
									size="small"
									@click.native.prevent="delSongHuoOrder(scope.row.ID)"
									v-if="isAdmin || scope.row.ISCANEDIT !== 'N'"
								></el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChangeSongHuo"
				@current-change="currentChangeSongHuo"
				:current-page="page_no"
				:page-sizes="pageSizes"
				:page-size="page_size"
				layout="total, sizes, prev, pager, next"
				:total="totalSize"
				class="tablePage"
			></el-pagination>
		</div>

		<!-- 创建订单dialog -->
		<el-dialog :title="dialogTitle" :visible.sync="showDialog" destroy-on-close :close-on-click-modal="false" center top="5vh" width="50%">
			<div class="dialog_row">
				<div class="dialog_item">
					<span class="dialog_item_title">{{ $t('message.CarNoTitle') }}:</span>
					<el-input v-model="CARNO" :placeholder="$t('message.placeholder')"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showDialog = false">{{ $t('message.cancleText') }}</el-button>
				<el-button type="primary" @click="addCarConfirm">{{ $t('message.confirmText') }}</el-button>
			</span>
		</el-dialog>
		<!-- 创建订单dialog -->

		<!-- 修改、添加送货订单 -->
		<el-dialog :title="$t('message.SongHuoXingChengTitle')" :visible.sync="SongHuoDialog" destroy-on-close :close-on-click-modal="false" center width="50%">
			<div class="dialog_box">
				<div class="dialog_row" style="display: none;">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.deliveryAddress') }}:</span>
						<el-input class="dialog_item_ipnut" :placeholder="$t('message.placeholder')" v-model="ADDRESS"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.XingChengTimeTitle') }}:</span>
						<el-input class="dialog_item_ipnut" :placeholder="$t('message.placeholder')" v-model="DETAILSTIME"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.SongHuoXingChengTitle') }}:</span>
						<el-input v-model="TRIP" :placeholder="$t('message.placeholder')" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }" style="flex-grow: 1;"></el-input>
					</div>
				</div>
				<div class="dialog_row" style="margin-bottom: 20px;">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderRemark') }}:</span>
						<el-input v-model="remark" :placeholder="$t('message.placeholder')" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" style="flex-grow: 1;"></el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer" style="margin-top: 200px;">
					<el-button @click="SongHuoDialog = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="editSongHuo">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 修改、添加送货订单 -->

		<!-- 绑定司机 -->
		<el-dialog :title="$t('message.SiJiTitle')" :visible.sync="headerDialog" destroy-on-close :close-on-click-modal="false" center width="30%">
			<div class="dialog_box">
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.driverArea') }}:</span>
						<el-select v-model="driverArea" :placeholder="$t('message.exportDatePlaceholder')" style="width: 100%;" @change="selectChange2">
							<el-option style="white-space:pre-line;" label="全部" value="全部"></el-option>
							<el-option style="white-space:pre-line;" label="東京" value="東京"></el-option>
							<el-option style="white-space:pre-line;" label="大阪" value="大阪"></el-option>
						</el-select>
					</div>
				</div>
				<div class="dialog_row" style="margin-bottom: 100px;">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.SiJiTitle') }}:</span>
						<el-select v-model="headerUserid" :placeholder="$t('message.exportDatePlaceholder')" style="width: 100%;" @change="selectChange">
							<el-option v-for="item in SiJiUserList" :key="item.USERID" :label="item.USHOWNAME" :value="item.USERID"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer" style="margin-top: 200px;">
					<el-button @click="headerDialog = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="editHeader">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 绑定司机 -->

		<!-- 绑定订单 -->
		<el-dialog :title="$t('message.SetOrderAndXingChengTitle')" :visible.sync="OrderDialog" destroy-on-close :close-on-click-modal="false" center width="50%">
			<div class="dialog_box">
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.LeiXingTitle') }}:</span>
						<el-select v-model="OrderTypeid" style="width: 100%;" @change="selectChangeType">
							<el-option :label="$t('message.QuHuoTitle')" value="Q"></el-option>
							<el-option :label="$t('message.SongHuoTitle')" value="S"></el-option>
						</el-select>
					</div>
				</div>
				<div class="dialog_row" v-if="showQ">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerTitle') }}:</span>
						<el-select v-model="Qid" :placeholder="$t('message.exportDatePlaceholder')" style="width: 100%;">
							<el-option
								v-for="item in orderListHaiWaiCang"
								:key="item.ID"
								:label="`${item.JZXSIZE}-${item.JZXNUM}-${item.CUSTOMERID}-${item.GPJC}-${item.SHULIANG}-${item.LITIJIN}`"
								:value="item.ID"
							></el-option>
						</el-select>
					</div>
				</div>
				<div class="dialog_row" v-if="showQ">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.XingChengTimeTitle') }}:</span>
						<el-input class="dialog_item_ipnut" :placeholder="$t('message.placeholder')" v-model="DETAILSTIMEQ"></el-input>
					</div>
				</div>
				<div class="dialog_row" v-if="showS">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerTitle') }}:</span>
						<el-select v-model="Sid" :placeholder="$t('message.exportDatePlaceholder')" style="width: 100%;">
							<el-option v-for="item in orderListSongHuoNo" :key="item.ID" :label="item.TRIP" :value="item.ID"></el-option>
						</el-select>
					</div>
				</div>
				<div class="dialog_row" style="margin-bottom: 20px;">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderRemark') }}:</span>
						<el-input v-model="REMARKX" :placeholder="$t('message.placeholder')" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" style="flex-grow: 1;"></el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer" style="margin-top: 200px;">
					<el-button @click="OrderDialog = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="SaveXingCheng">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 绑定订单 -->
	</div>
</template>

<script>
import {
	GetDiaoDuMain,
	getSongHuoOrder,
	setContainerOrder,
	delContainerOrder,
	updateContainerStatus,
	editSongHuo,
	delSongHuoOrder,
	addCarConfirm,
	SetLinShiCarNo,
	getDeliveryMenList,
	editHeader,
	BindDriver,
	selectChange,
	selectChange2,
	SetCarXingCheng,

	selectChangeType,
	getContainerOrder,
	SaveXingCheng,
	SetDiaoDuDetails,
	DelDiaoDuDetails,

	HTTPS
} from '@/api/getData.js';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
export default {
	name: 'DiaoDuOrder',
	data() {
		return {
			isAdmin: false,
			specialIdentity: '',
			date: '',
			city: '',
			page_no: 1,
			page_size: 100,
			pageSizes: [20, 50, 100, 200, 500, 1000],
			totalSize: 0,
			prop: null, // 排序字段
			order: '', // 排序方式
			orderList: [],
			orderListSongHuo: [],
			orderListSongHuoNo: [],
			orderListHaiWaiCang: [], //海外仓订单
			showDialog: false,
			SongHuoDialog: false,
			headerDialog: false, // 绑定司机dialog
			OrderDialog: false, //绑定订单
			dialogTitle: '',
			newOrder: 0,
			cityVal: '',
			remark: '', // 备注
			inspection: [], // 查验
			attacherFile: [], // 上传文件
			cityOptions: ['東京', '大阪'],
			cityOptionArea: '',
			driverArea: '',
			showAttachment: false,
			attachmentList: [],
			showKantoDialog: false,
			showKansaiDialog: false,
			showReturnReceiptDialog: false,
			showBillFilesDialog: false,
			tallyDialog: false,
			headerID: 0, // 当前订单id
			headerUserid: '', // 担当者userid
			TRIP: '', //行程
			ADDRESS: '', //送货地址
			DETAILSTIME: '', //行程时间
			DETAILSTIMEQ: '',
			SongHuoID: '', //送货订单id
			CARNO: '', //车牌号
			MainID: '', //当前主车辆编辑行ID
			SiJiUserid: '', //当前绑定司机ID
			SiJiUserList: [], //司机列表
			SelectSiJiName: '', //选中的司机名称
			SelectSiJiUserid: '', //选中的司机id
			Qid: '',
			Sid: '',
			OrderTypeid: 'S',
			showQ: false,
			showS: true,
			REMARKX: ''
		};
	},
	created() {
		this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin');
		this.specialIdentity = this.$store.state.JHSS.personalUserid !== 'administrator' ? this.$store.state.JHSS.personalSpecial : 'administrator';
		this.date = this.$route.query.date;
		this.tallyUploadDate = [this.$route.query.date, this.$route.query.date];
		this.city = this.$route.query.city;
		this.delayDate = this.date;
		this.getCustomer();
		this.GetDiaoDuMain();
		this.getSongHuoOrder();
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		async getCustomer() {
			// 查询司机列表
			let addres = { ADDRESS: this.cityOptionArea };
			let listadmin = await getDeliveryMenList(addres);
			if (listadmin.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			} else {
				this.SiJiUserList = listadmin.data.dt.map(item => {
					return item;
				});
			}
			//查询集装箱订单
			let param = { ISDIAODU: '0', DADATE: this.date, CITY: this.city, PAGE: 1, TYPE: 1000, ADDUSERID: this.$store.state.JHSS.personalUserid };

			let listHwc = await getContainerOrder(param);
			console.log(listHwc);
			if (listHwc.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			} else {
				this.orderListHaiWaiCang = listHwc.data.dt.map(item => {
					if (item.JZXNUM === null || item.JZXNUM === '') {
						item.JZXNUM = item.THDIZHI;
					}
					item.CUSTOMERID = item.CUSTOMERID.split(',')[0];
					return item;
				});
			}
		},
		// 查询集装箱订单
		async GetDiaoDuMain() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let param = { YMD: this.date, CITY: this.city, PAGE: this.page_no, TYPE: this.page_size };
			console.log(param);
			let res = await GetDiaoDuMain(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			this.totalSize = res.data.num;
			let _this = this;
			let index = 0;
			this.orderList = res.data.dt.map(item => {
				item.index = ++index;

				return item;
			});
		},
		sizeChange(val) {
			this.page_size = val;
			this.GetDiaoDuMain();
		},
		currentChange(val) {
			this.page_no = val;
			this.GetDiaoDuMain();
		},
		// 查询送货订单
		async getSongHuoOrder() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			//ISDIAODU:'0',
			let param = { YMD: this.date, CITY: this.city, PAGE: this.page_no, TYPE: this.page_size, ADDUSERID: this.$store.state.JHSS.personalUserid };
			let res = await getSongHuoOrder(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			// console.log(res.data)
			this.totalSize = res.data.num;
			let _this = this;
			this.orderListSongHuo = res.data.dt.map(item => {
				return item;
			});

			let paramNo = { STATE: '0', YMD: this.date, CITY: this.city, PAGE: this.page_no, TYPE: this.page_size, ADDUSERID: this.$store.state.JHSS.personalUserid };
			let resNo = await getSongHuoOrder(paramNo);
			if (resNo.status !== 200) {
				this.$message.error('network error：' + resNo.status);
				return;
			}
			this.orderListSongHuoNo = resNo.data.dt.map(item => {
				return item;
			});
			console.log('orderListSongHuoNo', this.orderListSongHuoNo);
		},
		sizeChangeSongHuo(val) {
			this.page_size = val;
			this.getSongHuoOrder();
		},
		currentChangeSongHuo(val) {
			this.page_no = val;
			this.getSongHuoOrder();
		},
		// 排序
		sortChangeSongHuo(obj) {
			// console.log(obj)
			// 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
			this.prop = null;
			if (obj.prop === 'arrivalTime') {
				this.prop = 'DADATE,DATIME';
			}
			if (obj.prop === 'JZXSIZE') {
				this.prop = 'JZXSIZE';
			}
			this.order = '';
			if (obj.order === 'descending') {
				this.order = 'DESC';
			}
			if (!obj.order) {
				this.prop = null;
			}
			this.getSongHuoOrder();
		},
		// 新建订单
		addNewOrder() {
			this.newOrder = 0;
			this.dialogTitle = this.$t('message.newContainerTitle');
			this.showDialog = true;
		},
		// 修改订单
		async updateSongHuoOrder(obj) {
			this.SongHuoDialog = true;
			this.dialogTitle = this.$t('message.SongHuoXingChengTitle');
			this.SongHuoID = obj.ID;
			this.ADDRESS = obj.ADDRESS;
			this.TRIP = obj.TRIP;
			this.remark = obj.REMARK;
			this.DETAILSTIME = obj.DETAILSTIME;
		},
		// 新建订单
		addSongHuoOrder() {
			this.SongHuoID = 0;
			this.YMD = this.date;
			this.dialogTitle = this.$t('message.SongHuoXingChengTitle');
			this.SongHuoDialog = true;
		},
		// 修改行程订单
		async editSongHuo(obj) {
			if (!this.TRIP) {
				this.$message(this.$t('message.containerGoodsModel'));
			} else {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					ID: this.SongHuoID,
					ADDRESS: this.ADDRESS,
					DETAILSTIME: this.DETAILSTIME,
					TRIP: this.TRIP,
					YMD: this.date,
					CITY: this.city,
					REMARK: this.remark,
					ADDUSER: this.$store.state.JHSS.personalUserid
				};
				let res = await editSongHuo(param);
				loading.close();
				if (res.status !== 200) {
					this.$message.error('network error：' + res.status);
				} else if (res.data.result !== '1') {
					this.$message.error(res.data.message);
				} else {
					this.SongHuoDialog = false;
					this.ADDRESS = '';
					this.TRIP = '';
					this.DETAILSTIME = '';
					this.REMARK = '';
					this.remark = '';
					this.page_no = this.newOrder === 0 ? 1 : this.page_no;
					this.getSongHuoOrder();
				}
			}
		},
		// 添加车辆
		async addCarConfirm(obj) {
			if (!this.CARNO) {
				this.$message(this.$t('message.PleaseAddCarNo'));
			} else {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					ID: 0,
					YMD: this.date,
					CITY: this.city,
					CARNO: this.CARNO
				};
				let res = await SetLinShiCarNo(param);
				loading.close();
				if (res.status !== 200) {
					this.$message.error('network error：' + res.status);
				} else if (res.data.result !== '1') {
					this.$message.error(res.data.message);
				} else {
					this.showDialog = false;
					this.page_no = this.newOrder === 0 ? 1 : this.page_no;
					this.GetDiaoDuMain();
				}
			}
		},
		// 绑定司机
		showHeaderDialog(id) {
			this.MainID = id;
			this.SiJiUserid = '';
			this.headerDialog = true;
		},
		selectChange2(val) {
			if (this.driverArea === '全部') {
				this.cityOptionArea = '';
				console.log(this.driverArea);
			} else {
				this.cityOptionArea = this.driverArea;
			}
			this.getCustomer();
		},
		selectChange(val) {
			console.log(val);
			var obj = {};
			obj = this.SiJiUserList.find(function(item) {
				return item.USERID === val;
			});
			this.SelectSiJiName = obj.USHOWNAME;
			this.SelectSiJiUserid = val;
			//console.log(obj)
			//console.log("label为", obj.USHOWNAME, "value为", val);
		},
		// 确定担当者
		async editHeader() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});

			let param = { ID: this.MainID, DRIVERUSERID: this.SelectSiJiUserid, DRIVER: this.SelectSiJiName };
			let res = await BindDriver(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.headerDialog = false;
				this.GetDiaoDuMain();
			}
		},
		async DelDiaoDuDetails(BangDingId) {
			let param = { ID: BangDingId };
			let res = await DelDiaoDuDetails(param);
			console.log('DelDiaoDuDetails', res);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.getCustomer();
				this.GetDiaoDuMain();
				this.getSongHuoOrder();
			}
		},
		//订单类型改变事件
		selectChangeType(val) {
			console.log(val);
			if (val === 'Q') {
				this.showQ = true;
				this.showS = false;
			}
			if (val === 'S') {
				this.showQ = false;
				this.showS = true;
			}
		},
		// 删除送货行程订单
		delSongHuoOrder(id) {
			this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
				confirmButtonText: this.$t('message.confirmText'),
				cancelButtonText: this.$t('message.cancleText')
			})
				.then(() => {
					this.del(id);
				})
				.catch(() => {
					this.$message(this.$t('message.canclePrompt'));
				});
		},
		async del(id) {
			let param = { ID: id };
			console.log(param);
			let res = await delSongHuoOrder(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.page_no = 1;
				this.getSongHuoOrder();
			}
		},
		// 设置行程
		async SetCarXingCheng(CarId, sortid) {
			console.log(CarId);
			console.log(sortid);
			this.MainID = CarId;
			this.OrderDialog = true;
		},
		async SaveXingCheng() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});

			//PID,SOQ,ORDERID，REMARK
			let param = {};
			if (this.OrderTypeid === 'Q') {
				param = { PID: this.MainID, SOQ: this.OrderTypeid, ORDERID: this.Qid, REMARK: this.REMARKX, DETAILSTIME: this.DETAILSTIMEQ };
			} else {
				param = { PID: this.MainID, SOQ: this.OrderTypeid, ORDERID: this.Sid, REMARK: this.REMARKX };
			}

			let res = await SetDiaoDuDetails(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.OrderDialog = false;
				this.Sid = '';
				this.Qid = '';
				this.DETAILSTIMEQ = '';
				this.REMARKX = '';
				this.GetDiaoDuMain();
				this.getSongHuoOrder();
				this.getCustomer();
			}
		},
		//导出调度车辆
		downloadBulkExcel() {
			let et = XLSX.utils.table_to_book(document.querySelector('.el-table__fixed')); //此处传入table的DOM节点
			let etout = XLSX.write(et, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(
					new Blob([etout], {
						type: 'application/octet-stream'
					}),
					`调度管理表.xlsx`
				); //导出的文件名
			} catch (e) {
				console.log(e, etout);
			}
			return etout;
		}
	},
	computed: {
		now() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1 > 9 ? now.getMonth() + 1 : '0' + (now.getMonth() + 1);
			let date = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
			let hour = now.getHours() > 9 ? now.getHours() : '0' + now.getHours();
			let minute = now.getMinutes() > 9 ? now.getMinutes() : '0' + now.getMinutes();
			let seconds = now.getSeconds() > 9 ? now.getSeconds() : '0' + now.getSeconds();
			return year + '/' + month + '/' + date + 'T' + hour + ':' + minute + ':' + seconds;
		}
	}
};

</script>

<style scoped>
.el-input {

	/* width: initial; */
	/* flex-grow: 1; */
}
/deep/ .el-textarea {
	width: 45%;
}
/deep/ .el-textarea__inner {
	text-align: left;
}
.color1 {
	color: #0048ff;
}
.color2 {
	color: #00cbc9;
}
.color3 {
	color: #ff8524;
}
.color4 {
	color: #00b7ff;
}
.color5 {
	color: #ffbb00;
}
.color6 {
	color: #9800ff;
}
.goSongHuoTitle {
	font-size: 1.25rem;
	color: #0048ff;
	font-weight: bold;
}
.sendEmailBtn {
	width: 25px;
	background: url(../../assets/sendEmailIcon.svg) no-repeat center;
}
/deep/ .demo-table-expand {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}
/deep/ .el-form-item {
	margin-bottom: 0;

}
</style>
